<template>
  <LayoutAccordionItemComponent
    :class="$style.root"
  >
    <template #heading>
      <div :class="$style.title">
        {{ title }}
      </div>
      <div
        :class="$style.subtitle"
        v-if="subtitle"
      >
        {{ subtitle }}
      </div>
    </template>

    <template #content>
      <CoreImageSliderComponent
        v-if="entry?.images?.data"
        :images="entry?.images?.data"
      />

      <CoreTextComponent
        v-if="description"
        :string="description"
        :class="$style.text"
      />
    </template>
  </LayoutAccordionItemComponent>
</template>


<script setup>
const props = defineProps({
  entry: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(props?.entry)
})

const title = computed(() => i18nGetLocalizedTitle(localizedData.value))
const subtitle = computed(() => i18nGetLocalizedString(localizedData.value?.subtitles))
const description = computed(() => i18nGetLocalizedString(localizedData.value?.descriptions))
</script>

<style module>
.root {
  --base--image--aspect-ratio: 9 / 6;
  --base--image--object-fit: cover;
}

.title,
.subtitle {
}

.text {
  composes: font-size-small from global;
  margin: var(--unit--vertical) 0;
}
</style>
